import React from "react";
import PropTypes from "prop-types";
import { addListener, removeListener } from "resize-detector";

const styles = {
  height: "100vh",
  overflowX: "hidden",
  overflowY: "auto",
  perspective: 2,
  backgroundColor: "#f2f6fa"
};

export default class ContentWrapper extends React.Component {
  state = { paddingTop: 0 };

  handleNavBarResize = () => {
    const navbar = document.getElementById("navbar");
    if (navbar) this.setState({ paddingTop: navbar.offsetHeight });
  };

  componentDidMount() {
    this.handleNavBarResize();
    const navbar = document.getElementById("navbar");
    if (navbar) addListener(navbar, this.handleNavBarResize);
  }

  componentWillUnmount() {
    const navbar = document.getElementById("navbar");
    if (navbar) removeListener(navbar, this.handleNavBarResize);
  }

  render() {
    return (
      <div
        style={{
          ...styles,
          ...this.props.style,
          paddingTop: this.state.paddingTop,
          scrollBehavior: "smooth"
        }}
        id={this.props.id}
      >
        {this.props.children}
      </div>
    );
  }
}

ContentWrapper.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object
};
